import { render, staticRenderFns } from "./MapWidget.vue?vue&type=template&id=45ac6cf0&scoped=true&"
import script from "./MapWidget.vue?vue&type=script&lang=js&"
export * from "./MapWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ac6cf0",
  null
  
)

export default component.exports